import React, { ReactNode } from 'react';
import { Tabs } from 'antd';
import './Tabs.less';

const { TabPane } = Tabs;

type TabsType = Array<{
  tabName?: ReactNode;
  disabled?: boolean;
  content?: ReactNode;
  tabKey?: string;
}>;
export type { TabsType };

export type TabsProps = {
  data: TabsType;
  centered?: boolean;
  defaultActiveKey?: string;
  activeKey?: string;
  size?: 'arge' | 'default' | 'small' | any;
  tabPosition?: 'top' | 'right' | 'bottom' | 'left';
  height?: string;
  tabBarStyle?: React.CSSProperties;
  tabBarExtraContent?: ReactNode | { left?: ReactNode; right?: ReactNode };
  onChange?: (activeKey: string) => void;
};

const TTabs: React.FC<TabsProps> = ({
  data,
  centered,
  defaultActiveKey,
  activeKey,
  size = 'default',
  tabPosition = 'top',
  height = 'auto',
  tabBarStyle = {},
  tabBarExtraContent,
  onChange,
}) => {
  const classNames = [];
  if (tabPosition === 'left') {
    classNames.push('t-tabs-container-left');
  }
  if (tabPosition === 'top') {
    classNames.push('t-tabs-container-top');
  }
  return (
    <div className={classNames.join('')}>
      <Tabs
        defaultActiveKey={defaultActiveKey}
        activeKey={activeKey}
        tabBarExtraContent={tabBarExtraContent}
        size={size}
        className="t-tabs"
        style={{ height: height }}
        centered={centered}
        tabPosition={tabPosition}
        tabBarStyle={tabBarStyle}
        onChange={onChange}
      >
        {data.map((i, index) => (
          <TabPane
            tab={i.tabName}
            key={i.tabKey || index}
            disabled={i.disabled}
          >
            {i.content}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default TTabs;
